import Footer from './components/page/Footer';
import Header from './components/page/Header';
import Middle from './components/page/Middle';
import JumpButton from './components/shared/JumpButton';

export default function App() {

    return (
        <>
            <Header />
            <Middle />
            <Footer />
            <JumpButton />
        </ >);
};